const componentRequireContext = require.context('components', true, /(GoogleSignIn|GoogleTagManager)/i);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);
ReactRailsUJS.detectEvents();
ReactRailsUJS.mountComponents();
